
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61574_22721)"}},[_c('path',{attrs:{"d":"M10.25 7a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0zM8 10.75c-.9 0-1.783.244-2.548.703A4.806 4.806 0 003.998 12.8 6.224 6.224 0 008 14.25a6.223 6.223 0 004.001-1.45c-.381-.54-.875-1-1.453-1.347A4.956 4.956 0 008 10.75zM15.75 8A7.75 7.75 0 11.25 8a7.75 7.75 0 0115.5 0zm-4-1a3.74 3.74 0 01-1.219 2.766 6.311 6.311 0 012.51 1.926 6.25 6.25 0 10-10.085 0 6.313 6.313 0 012.512-1.926A3.75 3.75 0 1111.75 7z","fill":"#4A4A4A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61574_22721"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    